exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".department-bonus-conditions[data-v-38ba4bef]{background:#f8f9fa;padding:20px;border-radius:8px;border:1px solid #dee2e6}.bonus-conditions-display table[data-v-38ba4bef]{margin-bottom:0}.bonus-conditions-edit .form-group[data-v-38ba4bef]{background:#fff;padding:15px;border-radius:5px;border:1px solid #dee2e6}.to-conditions-edit .card[data-v-38ba4bef]{border:1px solid #dee2e6;border-radius:8px}.to-conditions-edit .card-header[data-v-38ba4bef]{background-color:#f8f9fa;border-bottom:1px solid #dee2e6}.to-conditions-edit .form-label[data-v-38ba4bef]{font-weight:500;color:#495057;margin-bottom:5px}", ""]);

// exports
